import React from "react";
import StyleButton from "./StyleButton";

let Element = (props) => {
    let currentStyle = props.editorState.getCurrentInlineStyle ()
    return <span>
        { props.inlineControls.map (type =>
            <StyleButton
                key={ type.label }
                active={ currentStyle.has (type.style) }
                label={ type.label }
                onToggle={ props.onToggle }
                style={ type.style }
                icon={ type.icon }
            />
        ) }
    </span>
}

export default Element